import { jsxs, jsx } from 'react/jsx-runtime';
import { i18n } from '../../../utils/i18n.js';
import { Popover, Tooltip } from '@tecsinapse/cortex-react';
import { clsx } from 'clsx';
import { useState } from 'react';
import { TbWorld } from 'react-icons/tb';
import { Icon } from '../components/icon.js';
import { useMutation } from '@tanstack/react-query';
import { changeLocale } from '../../core/data/mutation.js';
import { useUserQuery } from '../../core/hooks/use-user-query.js';
import { useMenuAxios } from '../../core/context/axios.js';

const LanguageList = ({
  locales
}) => {
  const {
    data: user
  } = useUserQuery();
  const {
    instance
  } = useMenuAxios();
  const [open, setOpen] = useState(false);
  const {
    mutateAsync
  } = useMutation({
    mutationFn: (language) => changeLocale(instance, language)
  });
  const currentLocale = user?.idioma?.id ?? "PT_BR";
  const handleLanguage = async (language) => {
    try {
      await mutateAsync(language);
      location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      setOpen(false);
    }
  };
  return /* @__PURE__ */ jsxs(Popover.Root, { trigger: "click", controlled: true, isOpen: open, setIsOpen: setOpen, children: [
    /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, { text: i18n._(
      /*i18n*/
      {
        id: "frUGhT"
      }
    ), children: /* @__PURE__ */ jsx(TbWorld, { className: "text-secondary-medium hover:cursor-pointer", size: 24 }) }) }),
    /* @__PURE__ */ jsx(Popover.Content, { children: locales.map((locale) => /* @__PURE__ */ jsxs("button", { onKeyDown: async () => {
      await handleLanguage(locale.id);
    }, onClick: async () => {
      await handleLanguage(locale.id);
    }, className: clsx("flex items-center gap-x-mili hover:bg-secondary-light px-deca py-mili w-full", currentLocale === locale.id ? "bg-secondary-light" : "bg-white"), children: [
      /* @__PURE__ */ jsx(Icon, { idLanguage: locale.id }),
      /* @__PURE__ */ jsx("p", { children: locale.description })
    ] }, locale.id)) })
  ] });
};

export { LanguageList };
